import { DateTimePicker as MUIDateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';

const DateTimePicker = ({
  helper,
  label,
  error,
  value,
  ...props
}) => {
  let processedValue = null;

  if (value && typeof value === 'string') {
    processedValue = moment(value);
  } else if (value && typeof value === 'object') {
    processedValue = value;
  }

  return (
    <MUIDateTimePicker
      label={label}
      value={processedValue}
      slotProps={{
        textField: {
          error,
          helperText: helper,
        },
      }}
      {...props}
    />
  );
};

DateTimePicker.propTypes = {
  helper: PropTypes.string,
  label: PropTypes.string,
  error: PropTypes.bool,
  value: PropTypes.string,
};

export default DateTimePicker;
